import { createReducer, on } from "@ngrx/store";
import { IVessel, IVesselOrientation } from "../model";
import { IQueryResult } from "@pmis3/data-access";
import { LoadVessels, LoadVesselsSuccess, LoadVesselsFail, LoadVesselOrientations } from "../action/vessel.action";

export enum VesselStateStatus {
  LOADING = "loading",
  FAILED = "failed",
  PENDING = "pending",
  SUCCESS = "success",
  LOAD_VESSEL_ORIENTATIONS_SUCCESS = "load vessel orientations success"
}
export interface VesselState {
  vessels: IVessel[];
  error?: string;
  status: VesselStateStatus;
  vesselOrientations?: IVesselOrientation[]
}

export const initialVesselState: VesselState = {
    vessels: [],
    status: VesselStateStatus.PENDING,
    vesselOrientations: []
}

export const vesselReducer = createReducer(
    initialVesselState,
    on(LoadVessels, (state) => ({...state, status: VesselStateStatus.LOADING})),
    on(LoadVesselsSuccess, (state, {result: vessels }) => ({...state, vessels, status: VesselStateStatus.SUCCESS})),
    on(LoadVesselsFail, (state, { error }) => ({...state, error, status: VesselStateStatus.FAILED})),
    on(LoadVesselOrientations, (state, {vesselOrientations: vesselOrientations}) => ({...state, vessels: state.vessels, vesselOrientations: vesselOrientations, status: VesselStateStatus.LOAD_VESSEL_ORIENTATIONS_SUCCESS}))
)